<template>
  <div>
    <Toolbar
      :handle-submit="onSendForm"
      :handle-reset="resetForm"
      >
        <template slot="left">
          <v-toolbar-title v-if="item" class="hidden-md-and-down toolbartitle_50" >
            <h1><v-icon large>mdi-alert-decagram</v-icon>{{ item['titre'] }} - {{item['orderRef'].ref }}</h1>
          </v-toolbar-title>
        </template>
    </Toolbar>
    <OrderActionForm
      ref="updateForm"
      v-if="item"
      :values="item"
      :errors="violations"
    />
    <Loading :visible="isLoading || deleteLoading" />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { mapFields } from 'vuex-map-fields';
import OrderActionForm from '../../components/orderaction/Form.vue';
import Loading from '../../components/Loading';
import Toolbar from '../../components/Toolbar';
import UpdateMixin from '../../mixins/UpdateMixin';
import FileMixin from '../../mixins/FileMixin';

const servicePrefix = 'OrderAction';

export default {
  name: 'OrderActionUpdate',
  servicePrefix,
  mixins: [UpdateMixin,FileMixin],
  components: {
    Loading,
    Toolbar,
    OrderActionForm
  },
  data() {
    return {
      item: {
      }
    };
  },
  computed: {
    ...mapFields('orderaction', {
      deleteLoading: 'isLoading',
      isLoading: 'isLoading',
      error: 'error',
      updated: 'updated',
      violations: 'violations'
    }),
    ...mapGetters('orderaction', ['find'])

  },

  methods: {
    ...mapActions('orderaction', {
      deleteItem: 'del',
      retrieve: 'load',
      update: 'update',
    }),

  }
};
</script>
